import { atom } from 'jotai';

type ActivateSubscriptionModalAtom = {
  subscriptionId: number | undefined;
};

export const activateSubscriptionModalAtom = atom<ActivateSubscriptionModalAtom>({
  subscriptionId: undefined
});

activateSubscriptionModalAtom.debugLabel = 'activateSubscriptionModalAtom';
